import React from 'react';

const FormGlobalErrors = function(props) {
  if (!props.errors) {
    return null;
  }

  const errors = props.errors;
  let out = null;
  if (Array.isArray(errors)) {
    out = <ul className="mb-0">{errors.map((e, key) => <li key={key}>{e}</li>)}</ul>;
  } else if (typeof errors === 'object') {
    out = <ul className="mb-0">{Object.keys(errors).map((key, i) => <li key={i}>{errors[key]}</li>)}</ul>
  } else {
    out = <div>{props.errors}</div>;
  }


  return (
    <div className={`callout callout-danger mb-3 ${props.className || ''}`}>
      {out}
    </div>
  );
};

export default FormGlobalErrors;